import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useMemo } from 'react';
import '../../contexts/MenuContext/index.mjs';
import { SiteId } from '../../contexts/MenuContext/mapping.mjs';
import '../../hooks/index.mjs';
import '../../types/index.mjs';
import { imageSrc } from '../../utils/asset.mjs';
import '../Container/index.mjs';
import { ContainerWrap, InnerContainer, Wrap, ListsWrap, ListItemWrap, Header, List, ListItem, ListItemAnchor, InnerWrap, Form, InputWrap, Input, SubmitButton, IconsWrapper, IconWrapper, Break, StoreAddress, TermsWrap, FlexWrap, AnchorGroup, CookieBtn, Anchor, AnchorDivider, FlexWrapResponsive, Copyright } from './Footer.styles.mjs';
import { useFooterContent, FooterLinkId, COOKIE_POLICY_BTN_ID_CLASSNAME, COOKIE_POLICY_BTN_ID } from './hooks/useFooterContent.mjs';
import EN_TRANSLATION from './translations/en.json.mjs';
import { StoreId } from '../../types/generated.mjs';
import { useMenu } from '../../contexts/MenuContext/context.mjs';
import { useTranslation } from '../../hooks/useTranslation.mjs';
import { Language } from '../../types/constants.mjs';
import { Container } from '../Container/Container.mjs';
"use strict";
const subscribeRegionValue = {
  [StoreId.Us]: "United States",
  [StoreId.Eu]: "Europe",
  [StoreId.Ca]: "Canada",
  [StoreId.Za]: "South Africa",
  [StoreId.Me]: "Middle East",
  [StoreId.Uk]: "United Kingdom",
  [StoreId.In]: "India",
  [StoreId.Sg]: "Singapore",
  [StoreId.Br]: "Brazil",
  [StoreId.Jp]: "Japan",
  [StoreId.Mx]: "Mexico",
  [StoreId.Ph]: "Philippines",
  [StoreId.Tw]: "Taiwan",
  [StoreId.Cn]: "China"
};
const Footer = ({
  legalOnly,
  motif = "light",
  id,
  customer,
  storePicker,
  // storeBackendUrl,
  storeAddress,
  className
}) => {
  const {
    storeId,
    context
  } = useMenu();
  const {
    footerContent,
    socialContent,
    termsContent
  } = useFooterContent();
  const {
    formatMessage
  } = useTranslation({
    defaultTranslation: EN_TRANSLATION,
    additionalTranslations: {
      [Language.Ar]: () => import('./translations/ar.json.mjs').then(res => res.default),
      [Language.Ca]: () => import('./translations/ca.json.mjs').then(res => res.default),
      [Language.Cs]: () => import('./translations/cs.json.mjs').then(res => res.default),
      [Language.Da]: () => import('./translations/da.json.mjs').then(res => res.default),
      [Language.Nl]: () => import('./translations/nl.json.mjs').then(res => res.default),
      [Language.Fr]: () => import('./translations/fr.json.mjs').then(res => res.default),
      [Language.De]: () => import('./translations/de.json.mjs').then(res => res.default),
      [Language.El]: () => import('./translations/el.json.mjs').then(res => res.default),
      [Language.It]: () => import('./translations/it.json.mjs').then(res => res.default),
      [Language.Ja]: () => import('./translations/ja.json.mjs').then(res => res.default),
      [Language.Ko]: () => import('./translations/ko.json.mjs').then(res => res.default),
      [Language.No]: () => import('./translations/no.json.mjs').then(res => res.default),
      [Language.Pl]: () => import('./translations/pl.json.mjs').then(res => res.default),
      [Language.PtPt]: () => import('./translations/pt-PT.json.mjs').then(res => res.default),
      [Language.EsMx]: () => import('./translations/es-MX.json.mjs').then(res => res.default),
      [Language.Sv]: () => import('./translations/sv.json.mjs').then(res => res.default),
      [Language.Tr]: () => import('./translations/tr.json.mjs').then(res => res.default),
      [Language.Zh]: () => import('./translations/zh-Hans.json.mjs').then(res => res.default),
      [Language.Tw]: () => import('./translations/zh-Hant-TW.json.mjs').then(res => res.default),
      [Language.PtBr]: () => import('./translations/pt-BR.json.mjs').then(res => res.default),
      [Language.Ru]: () => import('./translations/ru.json.mjs').then(res => res.default),
      [Language.EsEs]: () => import('./translations/es-ES.json.mjs').then(res => res.default)
    }
  });
  const hiddenFields = useMemo(() => {
    return {
      // Merge fields are based on Mailchimp settings
      u: "bc856e62a9254399365d0277b",
      id: "1c1b02cb37",
      MERGE1: customer?.firstName,
      MERGE2: customer?.lastName,
      // Always set the user as residential as we don't have any other type of user
      MERGE4: "Residential (home use)",
      // Always set the user as subscribed to all lists
      MERGE3: "subscribed",
      MERGE7: "subscribed",
      MERGE8: "subscribed",
      // Store region value expected in two fields
      MERGE6: subscribeRegionValue[storeId],
      MERGE9: subscribeRegionValue[storeId]
    };
  }, [customer?.firstName, customer?.lastName, storeId]);
  return /* @__PURE__ */jsx(ContainerWrap, {
    $motif: motif,
    id,
    className,
    children: /* @__PURE__ */jsx(Container, {
      size: "desktop",
      noVerticalMargin: true,
      children: /* @__PURE__ */jsxs(InnerContainer, {
        children: [!legalOnly && /* @__PURE__ */jsxs(Fragment, {
          children: [/* @__PURE__ */jsxs(Wrap, {
            children: [/* @__PURE__ */jsx(ListsWrap, {
              children: Object.values(footerContent).map((list, i) => /* @__PURE__ */jsxs(ListItemWrap, {
                children: [/* @__PURE__ */jsxs(Header, {
                  children: [" ", list.header.label]
                }), /* @__PURE__ */jsx(List, {
                  children: list.items.map((item, j) => /* @__PURE__ */jsx(ListItem, {
                    children: /* @__PURE__ */jsx(ListItemAnchor, {
                      href: item.src,
                      target: item.target,
                      children: item.label
                    })
                  }, `footer-list-${i}-item-${j}`))
                })]
              }, `footer-list-${i}`))
            }), /* @__PURE__ */jsxs(InnerWrap, {
              children: [/* @__PURE__ */jsxs(Form, {
                method: "get",
                action: "https://ui.us8.list-manage.com/subscribe",
                target: "_blank",
                children: [/* @__PURE__ */jsx(Header, {
                  children: formatMessage("footer.newsletter.touch")
                }), Object.entries(hiddenFields).map(([key, value]) => /* @__PURE__ */jsx("input", {
                  type: "hidden",
                  name: key,
                  value
                }, key)), /* @__PURE__ */jsxs(InputWrap, {
                  children: [/* @__PURE__ */jsx(Input, {
                    type: "text",
                    pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+",
                    minLength: 6,
                    maxLength: 254,
                    required: true,
                    autoCapitalize: "off",
                    autoCorrect: "off",
                    placeholder: formatMessage("footer.newsletter.email"),
                    name: "EMAIL"
                  }), /* @__PURE__ */jsx(SubmitButton, {
                    type: "submit",
                    className: motif,
                    variant: "primary",
                    children: formatMessage("footer.newsletter.subscribe")
                  })]
                })]
              }), /* @__PURE__ */jsx(IconsWrapper, {
                children: socialContent.items.map(socialItem => /* @__PURE__ */jsx(IconWrapper, {
                  href: socialItem.src,
                  target: socialItem.target,
                  children: socialItem.icon ? /* @__PURE__ */jsx("img", {
                    src: imageSrc(socialItem.icon),
                    alt: socialItem.label
                  }) : socialItem.label
                }, `footer-social-link-${socialItem.label}`))
              })]
            })]
          }), /* @__PURE__ */jsx(Break, {
            $motif: motif
          })]
        }), context === SiteId.Store && storeAddress && /* @__PURE__ */jsxs(Fragment, {
          children: [/* @__PURE__ */jsx(StoreAddress, {
            children: storeAddress
          }), /* @__PURE__ */jsx(Break, {
            $motif: motif
          })]
        }), /* @__PURE__ */jsxs(TermsWrap, {
          children: [/* @__PURE__ */jsx(FlexWrap, {
            children: termsContent.items.map((term, i) => /* @__PURE__ */jsxs(AnchorGroup, {
              children: [term.id === FooterLinkId.Cookie ? /* @__PURE__ */jsx(CookieBtn, {
                type: "button",
                id: COOKIE_POLICY_BTN_ID,
                className: COOKIE_POLICY_BTN_ID_CLASSNAME,
                children: term.label
              }, `footer-term-${term.id}`) : /* @__PURE__ */jsx(Anchor, {
                href: term.src,
                target: term.target,
                "aria-label": term.label,
                children: term.label
              }), /* @__PURE__ */jsx(AnchorDivider, {
                children: i !== termsContent.items.length - 1 && "|"
              })]
            }, `footer-term-${term.id}`))
          }), /* @__PURE__ */jsxs(FlexWrapResponsive, {
            children: [storePicker, /* @__PURE__ */jsxs(Copyright, {
              children: ["\xA9 ", (/* @__PURE__ */new Date()).getFullYear(), " ", formatMessage("footer.copyright")]
            })]
          })]
        })]
      })
    })
  });
};
export { Footer };
//# sourceMappingURL=Footer.mjs.map
